import { PayinOrderStatus } from '~/entities/payin';

export const isCancelEnabled = (status?: PayinOrderStatus) => {
    return status === PayinOrderStatus.STATUS_CREATED;
};
